const hy = {
  // Navigation
  home: "Գլխավոր",
  products: "Ապրանքներ",
  about: "Մեր մասին",
  contact: "Կապ",
  
  // Hero Section
  heroTitle: "Loveish",
  heroSlogan: "Համտեսեք սերը",
  heroDescription: "Բացահայտեք մեր պրեմիում հավաքածուն չորացրած մրգերի, ընկույզների, քաղցրավենիքների, թթվասերների և մուրաբաների: Պատրաստված սիրով, առաքված խնամքով:",
  shopNow: "Գնել հիմա",
  learnMore: "Իմանալ ավելին",
  
  // Products
  driedFruits: "Չորացրած մրգեր",
  driedFruitsDesc: "Բարձրակարգ չորացրած մրգեր՝ լի բնական քաղցրությամբ",
  nuts: "Ընկույզներ",
  nutsDesc: "Թարմ և սննդարար ընկույզներ առողջ նախուտեստների համար",
  sweets: "Քաղցրավենիք",
  sweetsDesc: "Ավանդական պարսկական քաղցրավենիք՝ ավթենտիկ բաղադրատոմսերով",
  pickles: "Թթվասեր",
  picklesDesc: "Համեղ թթվասերված բանջարեղեն և ձիթապտուղ",
  jams: "Մուրաբա",
  jamsDesc: "Տնական մուրաբա՝ լի բնական մրգային համերով",
  
  // Product Items
  walnuts: "Ընկույզ",
  almonds: "Հում և աղած նուշ",
  pistachios: "Հում, զաֆրանով և աղած ֆստուկ",
  peanuts: "Գետնանուշ",
  hazelnuts: "Պնդուկ",
  chickpeas: "Սիսեռ և չամիչ",
  
  mangoLeaves: "Մանգոյի տերև",
  peaches: "Դեղձ",
  plums: "Սալոր",
  apple: "Խնձոր",
  banana: "Բանան",
  strawberries: "Ելակ",
  yellowPlums: "Դեղին սալոր",
  pineapples: "Արքայախնձոր",
  figs: "Թուզ",
  bukharaPlums: "Բուխարական սալոր",
  
  gaz: "Գազ",
  sohan: "Սոհան",
  latifeh: "Լատիֆե",
  kalampeh: "Կալամպե",
  fasaeiBread: "Ֆասաեի հաց",
  datesArdeh: "Խուրմա և արդե",
  iceCream: "Պաղպաղակ և ֆալուդե",
  pashmak: "Պաշմակ Հաջ Աբդուլլահ",
  
  lyte: "Տարբեր տեսակի լիտե",
  pearlGarlic: "Մարգարիտ սխտոր",
  olives: "Ձիթապտուղ",
  cultivatedOlives: "Մշակված ձիթապտուղ",
  
  strawberryJam: "Ելակի մուրաբա",
  carrotJam: "Գազարի մուրաբա",
  blackcurrantJam: "Սև հաղարջի մուրաբա",
  honey: "Մեղր",
  
  // About
  aboutTitle: "Loveish-ի մասին",
  aboutDescription: "Մենք կիրքով ենք զբաղվում ավանդական և ժամանակակից սննդամթերքի լավագույն ընտրանիքի տրամադրմամբ: Մեր հանձնառությունը որակի և ավթենտիկ համերի նկատմամբ յուրաքանչյուր կծիկը դարձնում է անմոռանալի փորձառություն:",
  
  // Contact
  contactTitle: "Կապվեք մեզ հետ",
  contactDescription: "Մենք կցանկանայինք լսել ձեզանից: Կապվեք մեզ հետ մեր ապրանքների վերաբերյալ ցանկացած հարցման համար:",
  messageSentSuccess: "Շնորհակալություն! Ձեր հաղորդագրությունը հաջողությամբ ուղարկվել է:",
  messageSentError: "Վայ! Ինչ-որ բան սխալ է: Խնդրում ենք կրկին փորձել:",
  
  // Footer
  quickLinks: "Արագ հղումներ",
  followUs: "Հետևեք մեզ",
  allRightsReserved: "Բոլոր իրավունքները պաշտպանված են",
  footerDescription: "Պրեմիում պարսկական ընկույզներ, չորացրած մրգեր, ավանդական քաղցրավենիք և արհեստական արտադրանք՝ առաքված սիրով:",
  customerService: "Հաճախորդների սպասարկում",
  faq: "ՀՏՀ",
  privacyPolicy: "Գաղտնիության քաղաքականություն",
  support: "Աջակցություն",
  newsletter: "Տեղեկագիր",
  newsletterDescription: "Բաժանորդագրվեք՝ հատուկ առաջարկներ և թարմացումներ ստանալու համար",
  enterEmail: "Մուտքագրեք ձեր էլ. փոստը",
  subscribe: "Բաժանորդագրվել",
  
  // Common
  viewAll: "Տեսնել բոլորը",
  addToCart: "Ավելացնել զամբյուղ",
  buyNow: "Գնել հիմա",
  shoppingCart: "Զամբյուղ",
  emptyCart: "Ձեր զամբյուղը դատարկ է",
  clearCart: "Մաքրել զամբյուղը",
  checkout: "Վճարել",
  total: "Ընդամենը",
  checkoutSuccess: "Շնորհակալություն ձեր պատվերի համար: Մենք շուտով կկապվենք ձեզ հետ:",
  
  // Cart Page
  cartItems: 'Զամբյուղի ապրանքներ',
  clearAll: 'Մաքրել բոլորը',
  continueShopping: 'Շարունակել գնումները',
  orderSummary: 'Պատվերի ամփոփում',
  freeShippingProgress: 'Անվճար առաքման առաջընթաց',
  subtotal: 'Ենթագումար',
  shipping: 'Առաքում',
  tax: 'Հարկ',
  calculatedAtCheckout: 'Հաշվարկվում է վճարման ժամանակ',
  proceedToCheckout: 'Անցնել վճարման',
  havePromoCode: 'Ունե՞ք զեղչի կոդ',
  enterCode: 'Մուտքագրեք կոդը',
  apply: 'Կիրառել',
  whyShopWithUs: 'Ինչու գնել մեզանից',
  securePayment: '100% Անվտանգ վճարում',
  returnPolicy: '30-օրյա վերադարձի քաղաքականություն',
  customerSupport: '24/7 Հաճախորդների աջակցություն',
  qualityGuaranteed: 'Պրեմիում որակ երաշխավորված',
  clearCartConfirm: 'Մաքրե՞լ զամբյուղը',
  clearCartMessage: 'Վստա՞հ եք, որ ցանկանում եք հեռացնել բոլոր ապրանքները զամբյուղից: Այս գործողությունը հնարավոր չէ հետ շրջել:',
  cancel: 'Չեղարկել',
  itemTotal: 'Ապրանքների ընդհանուր',
  addMoreForFreeShipping: 'Ավելացրեք {amount} ևս անվճար առաքման համար!',
  yourCartIsEmpty: 'Ձեր զամբյուղը դատարկ է',
  emptyCartMessage: 'Կարծես դեռ ոչինչ չեք ավելացրել: Սկսեք գնումները և բացահայտեք մեր հիանալի ապրանքները!',
  startShopping: 'Սկսել գնումները',
  yourCart: 'Ձեր զամբյուղը',
  
  // Products Page
  ourProducts: "Մեր ապրանքները",
  searchProducts: "Որոնել ապրանքներ...",
  featuredCategories: "Առանձնահատուկ կատեգորիաներ",
  specialGifts: "Հատուկ նվերներ",
  
  // Auth
  login: "Մուտք",
  logout: "Ելք",
  profile: "Պրոֆիլ",
  welcomeBack: 'Բարի վերադարձ',
  loginToAccount: 'Մուտք գործեք ձեր հաշիվ',
  createAccount: 'Ստեղծել հաշիվ',
  joinLoveish: 'Միացեք Loveish-ին այսօր',
  email: 'Էլ. փոստ',
  password: 'Գաղտնաբառ',
  confirmPassword: 'Հաստատել գաղտնաբառը',
  firstName: 'Անուն',
  lastName: 'Ազգանուն',
  enterPassword: 'Մուտքագրեք ձեր գաղտնաբառը',
  enterFirstName: 'Մուտքագրեք ձեր անունը',
  enterLastName: 'Մուտքագրեք ձեր ազգանունը',
  signIn: 'Մուտք',
  signingIn: 'Մուտք գործում...',
  creatingAccount: 'Հաշիվ ստեղծում...',
  forgotPassword: 'Մոռացե՞լ եք գաղտնաբառը',
  verificationEmailSent: 'Հաստատման նամակն ուղարկված է!',
  checkEmailToVerify: 'Խնդրում ենք ստուգել ձեր էլ. փոստը և սեղմել հաստատման հղումը՝ ձեր հաշիվը ակտիվացնելու համար:',
  emailVerified: 'Էլ. փոստը հաջողությամբ հաստատվեց!',
  canNowLogin: 'Այժմ կարող եք մուտք գործել ձեր հաշիվ:',
  soldOut: 'ՎԱՃԱՌՎԱԾ Է',
  comingSoon: 'Շուտով',
  notifyWhenAvailable: 'Ծանուցել հասանելի լինելու դեպքում',
  outOfStock: 'Պահեստում չկա'
};

export default hy;
